/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * TenFrameElement.tsx - A square for the ten frame.
*/

import { StyleSheet, View, Image, ViewStyle } from 'react-native';
import { RFPercentage } from 'react-native-responsive-fontsize';
import { ImageRequire } from '../../../../types';

interface TenFrameElementProps {
  width: number,
  height: number,
  margin: number,
  color: 'red' | 'yellow' | 'none'
  isFilled: boolean;
  isSubtract?: boolean;
  image?: ImageRequire;
}

const TenFrameElement = ({width, height, margin, color, isFilled, isSubtract, image}: TenFrameElementProps) => {

  const squareStyle: ViewStyle[] = [styles.square, {width:width, height:height, margin: margin} ];
  if(image){
    return(
      <View style={squareStyle}>
        <Image source={image} style={styles.imageSquare} />
      </View>
    );
  }

  if (isFilled) {
    if (color === 'red') {
      if (isSubtract) {
        return (
          <View style={squareStyle}>
            <View style={styles.redCircleSubtract}>
              <View style={[styles.line, {
                transform: [{ rotate: '-45deg' }]
              }]}
              />
            </View>
          </View>
        );
      }

      return (
        <View style={squareStyle}>
          <View style={styles.redCircle} />
        </View>
      );
    }

    return (
      <View style={squareStyle}>
        <View style={styles.yellowCircle} />
      </View>
    );
  }

  return (
    <View style={squareStyle}>
      <View style={styles.emptyCircle} />
    </View>
  );

};

export default TenFrameElement;

const styles = StyleSheet.create({
  square: {
    color: '#20232a',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: 'black',
    overflow: 'hidden',
    backgroundColor: 'white',
    padding: '1%',
    margin: '1%',
  },

  imageSquare: {
    resizeMode: 'contain',
    height: '100%',
    width: '100%',
    alignSelf: 'center',
    aspectRatio: 1
  },
  
  redCircle: {
    height: '100%',
    aspectRatio: 1,
    borderRadius: 100,
    backgroundColor: '#EB3324',
    borderColor: 'black',
    borderWidth: 2,
  },

  redCircleSubtract: {
    height: '100%',
    aspectRatio: 1,
    borderRadius: 100,
    backgroundColor: '#EB3324',
    justifyContent: 'center',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderColor: 'black',
    borderWidth: 2,
  },

  subtractText: {
    lineHeight: 110,
    fontSize: RFPercentage(9),
  },

  yellowCircle: {
    height: '100%',
    aspectRatio: 1,
    borderRadius: 100,
    backgroundColor: '#FEFF54',
    borderColor: 'black',
    borderWidth: 2,
  },

  emptyCircle: {
    height: '90%',
    aspectRatio: 1,
  },

  line: {
    borderWidth: 2,
    height: 2,
    width: '130%',
    borderColor: 'black'
  }
});
